import TemplateView from '../../../../../TemplateView'

/**
 * @author makovchik.
 * @since 16.08.2018.
 */
export default class ActionButton extends TemplateView {
    constructor({
        title = '',
        extraClass = '',
        actionClick = () => {},
        hideMenu = {},
    }) {
        super()

        this.params = {
            title,
            extraClass,
        }

        this.callbacks = {
            actionClick,
            hideMenu,
        }
    }

    templateHtml() {
        return "  <div class='item <%-extraClass%>'>" +
               "    <div class='img'></div>" +
               "    <div class='action'><%-title%></div>" +
               "  </div>"
    }

    templateModel() {
        return {
            title: this.params.title,
            extraClass: this.params.extraClass,
        }
    }

    afterRender() {
        this.bindClick(this.releaseActions)
    }

    releaseActions(e) {
        e.stopPropagation()
        this.callbacks.actionClick()
        this.callbacks.hideMenu(true)
    }
}




// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/components/action/ActionButton.js